import { useState } from 'react';
import { Dialog, TextField } from '@dugzi/ui';
import { api } from '../lib/api';
import type { DriveNode } from '../lib/types';

export function RenameDialog({ node, onClose }: { node: DriveNode; onClose(changed: boolean): void }) {
  const [name, setName] = useState(node.name);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (name.trim() === node.name) { onClose(false); return; }
    setBusy(true);
    try { await api(`/api/nodes/${node.id}`, { method: 'PATCH', body: { name } }); onClose(true); } catch (e) { setError((e as Error).message); setBusy(false); }
  };
  // Select the name without its extension, as Finder and Explorer do.
  const dot = node.kind === 'file' ? node.name.lastIndexOf('.') : -1;
  return (
    <Dialog open onClose={() => onClose(false)} title="Rename" actions={<>
      <button type="button" className="dz-btn dz-btn--ghost" onClick={() => onClose(false)}>Cancel</button>
      <button type="button" className="dz-btn dz-btn--primary" onClick={save} disabled={busy} data-testid="rename-save">Save</button>
    </>}>
      <form onSubmit={(e) => { e.preventDefault(); save(); }}>
        <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} autoFocus maxLength={255} error={error ?? undefined} data-testid="rename-input"
          onFocus={(e) => e.target.setSelectionRange(0, dot > 0 ? dot : node.name.length)} />
      </form>
    </Dialog>
  );
}
